import { FC, ReactNode } from "react";
import { Collapse } from "antd";
import { StyledCollapse, StyledText } from "./styled";
import { ArrowDown } from "../icons/ArrowDown";

interface ITransparentCollapseProps {
  className?: string;
  isOpenedByDefault?: boolean;
  title: ReactNode;
  children: ReactNode;
  onChange?: (value: string | string[]) => void;
}

export const TransparentCollapse: FC<ITransparentCollapseProps> = ({
  children,
  className,
  isOpenedByDefault,
  title,
  onChange,
}) => (
  <StyledCollapse
    expandIcon={()=> (<div className="arrow-icon">
    <ArrowDown  />
    </div>)}
    bordered={false}
    className={className}
    defaultActiveKey={isOpenedByDefault ? "default" : ""}
    onChange={onChange}
  >
    <Collapse.Panel
      key="default"
      header={<StyledText color={"#434343"}>{title}</StyledText>}
    >
      {children}
    </Collapse.Panel>
  </StyledCollapse>
);
